import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { selectRole } from '../RoleSelector/roleselector.js';
import { selectRoleMobile } from '../RoleSelectorMobile/roleselectormobile.js';
import { bindArea } from '../AreaBind/areabind';
import { getPersonInfo, miloCore } from '@tencent/milo-core';
import FormManager from '../util/form';
import { ProvinceCitySelector } from '../CitySelector/cityselector';
import { commonFail } from '../util/base';
import { appendHtml, findNodeByClass } from '../util/domHelper';
import { miloAlert } from '../AlertDialog';
import request from '../api';
import tpl from './tpl';
import './tpl.css';

var ShipAddressComp = /*#__PURE__*/function () {
  function ShipAddressComp(option) {
    _classCallCheck(this, ShipAddressComp);

    this.option = _objectSpread({
      plat: 'pc',
      iActivityId: '',
      iFlowId: '',
      flowConfig: {
        sData: {
          iShow: 1,
          iHasGet: 0,
          sInfoSvrVersion: 'v0112'
        },
        formData: null
      },
      extendRole: {},
      contentId: "shipAddress_".concat(option.iFlowId),
      formContentId: "shipAddress_form_".concat(option.iFlowId),
      packageContentId: "package_".concat(option.iFlowId),
      orderContentId: "order_".concat(option.iFlowId),
      submitContentId: "submitBtn_".concat(option.iFlowId),
      onSubmitSuccess: null,
      onSubmitFail: null,
      onValidator: null
    }, option);
    this.dialogRender = null;
  }

  _createClass(ShipAddressComp, [{
    key: "query",
    value: function query(_onSuccess, onFail) {
      var self = this;
      request(getPersonInfo, self.option).then(function (res) {
        console.log('getPersonInfo', res);

        if (res && res.jData) {
          var jData = res.jData;

          if (typeof jData.iGender === 'undefined') {
            jData.iGender = '1';
          } // if (jData.arrPackageInfo && jData.arrPackageInfo.length) {


          if (_onSuccess && miloCore.isFunction(_onSuccess)) {
            _onSuccess(res);
          }

          self.renderDefault(jData); // } else {
          //   commonFail(res, '未获得实物不能填写,请先获得实物', onFail);
          // }
        } else {
          commonFail(res, res.sMsg || '网络繁忙，请稍后重试', onFail);
        }
      })["catch"](function (err) {
        if (err.errCode === 3) {
          var selectRoleFn = self.option.plat === 'mobile' ? selectRoleMobile : selectRole;
          selectRoleFn(_objectSpread(_objectSpread(_objectSpread({}, err.rsOption), self.option.extendRole), {}, {
            onSubmit: function onSubmit(role) {
              var sData = self.option.flowConfig.sData || {};
              self.option.flowConfig.sData = _objectSpread(_objectSpread({}, sData), {}, {
                sServiceType: err.rsOption.gameId,
                sArea: role.area,
                sPartition: role.partition,
                sRoleId: role.roleId,
                sAreaName: role.areaName,
                sRoleName: role.roleName,
                md5str: role.md5str,
                iSex: role.roleSex || '',
                sPlatId: role.platid,
                ams_checkparam: role.checkparam,
                checkparam: role.checkparam
              });
              self.query(_onSuccess, onFail);
            }
          }));
        } else if (err.errCode === 2) {
          bindArea({
            bindOptions: _objectSpread(_objectSpread({}, err.areaBindOption), {}, {
              flowConfig: _objectSpread({}, self.option.extendRole),
              onSuccess: function onSuccess() {
                self.query(_onSuccess, onFail);
              }
            }),
            type: 'commit'
          });
        } else {
          // console.log(err);
          if (err.errCode && parseInt(err.errCode) === -1) {
            // 登陆错误统一处理
            return;
          }

          commonFail(err, err.errMsg || '网络繁忙，请稍后重试', onFail);
        }
      });
    }
  }, {
    key: "submit",
    value: function submit(formData, onSuccess, onFail) {
      var _ref = this.option.flowConfig || {},
          sData = _ref.sData;

      this.option.flowConfig.sData = _objectSpread(_objectSpread(_objectSpread({}, sData), formData), {}, {
        iShow: 0
      });
      request(getPersonInfo, this.option).then(function (res) {
        if (res && res.iRet === '0') {
          onSuccess(res);
        } else {
          onFail({
            res: res,
            errMsg: res.errMsg
          });
        }
      })["catch"](function (err) {
        if (err.errCode && parseInt(err.errCode) === -1) {
          // 登陆错误统一处理
          return;
        }

        onFail({
          res: err,
          errMsg: err.sMsg
        });
      });
    } // 渲染默认模板

  }, {
    key: "renderDefault",
    value: function renderDefault(info) {
      var self = this;

      var _ref2 = info || {},
          _ref2$arrPackageInfo = _ref2.arrPackageInfo,
          arrPackageInfo = _ref2$arrPackageInfo === void 0 ? [] : _ref2$arrPackageInfo,
          _ref2$arrAddressInfo = _ref2.arrAddressInfo,
          arrAddressInfo = _ref2$arrAddressInfo === void 0 ? [] : _ref2$arrAddressInfo;

      var _self$option = self.option,
          iFlowId = _self$option.iFlowId,
          plat = _self$option.plat,
          contentId = _self$option.contentId,
          packageContentId = _self$option.packageContentId;
      self.dialogRender = document.getElementById(contentId);

      if (!self.dialogRender) {
        var addressHtml = tpl(iFlowId);
        appendHtml(document.body, addressHtml, "personInfoContent_".concat(iFlowId));
        self.dialogRender = document.getElementById(contentId);
      }

      var className = plat === 'pc' ? 'gift-ship-address-dialog' : 'gift-ship-address-dialog-mobile';

      if (self.dialogRender) {
        self.dialogRender.setAttribute('class', className);
        self.dialogRender.style.display = 'block';
      } // packageId下拉选择器初始化


      var packageIdSelector = document.getElementById(packageContentId);

      if (packageIdSelector) {
        arrPackageInfo.forEach(function (packageInfo, i) {
          var _ref3 = packageInfo || {},
              iPackageId = _ref3.iPackageId,
              sPackageName = _ref3.sPackageName;

          packageIdSelector.options[i] = new Option(sPackageName, "".concat(iPackageId, "|").concat(sPackageName));
        });
        self.bindEvents(iFlowId);
        var address = {};

        if (arrPackageInfo.length && arrAddressInfo.length) {
          address = arrAddressInfo.find(function (item) {
            return item.iPackageId === arrPackageInfo[0].iPackageId;
          });
        }

        self.renderForm(address); // 切换礼包

        packageIdSelector.onchange = function (e) {
          var packageId = e.target.value.split('|')[0];
          var selectedAddress = arrAddressInfo ? arrAddressInfo.find(function (item) {
            return item.iPackageId === packageId;
          }) : null;

          if (selectedAddress) {
            self.renderForm(selectedAddress);
          } else {
            var formData = FormManager.getAllInputValue(self.option.formContentId);
            var newFormData = {};
            Object.keys(formData).forEach(function (x) {
              if (x === 'sPackageInfo') newFormData[x] = formData[x];
              newFormData[x] = '';
            });
            self.renderForm(newFormData);
          }
        };
      }
    }
  }, {
    key: "renderForm",
    value: function renderForm(address) {
      var _this$option = this.option,
          iFlowId = _this$option.iFlowId,
          orderContentId = _this$option.orderContentId,
          formContentId = _this$option.formContentId;
      var pcsConfig = {
        provinceId: "province_".concat(iFlowId),
        cityId: "city_".concat(iFlowId),
        areaId: "county_".concat(iFlowId)
      };

      var _ref4 = address || {},
          sProvince = _ref4.sProvince,
          sCity = _ref4.sCity,
          sExtend2 = _ref4.sExtend2,
          sExtend1 = _ref4.sExtend1;

      if (sProvince && sCity) {
        pcsConfig.initVal = [sProvince, sCity];
        sExtend2 && pcsConfig.initVal.push(sExtend2);
      }

      ProvinceCitySelector.init(pcsConfig);
      FormManager.setAllInputValue(address, formContentId);
      if (document.getElementById(orderContentId)) document.getElementById(orderContentId).innerHTML = sExtend1 || '暂无';
    }
  }, {
    key: "commonValidator",
    value: function commonValidator(data, validatorFun) {
      if (validatorFun && miloCore.isFunction(validatorFun)) {
        validatorFun(data);
      } else {
        miloAlert(data.val);
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var self = this;
      var _self$option2 = self.option,
          submitContentId = _self$option2.submitContentId,
          formContentId = _self$option2.formContentId,
          onSubmitSuccess = _self$option2.onSubmitSuccess,
          onSubmitFail = _self$option2.onSubmitFail,
          onValidator = _self$option2.onValidator,
          beforeSubmit = _self$option2.beforeSubmit;
      if (document.getElementById(submitContentId)) document.getElementById(submitContentId).onclick = function () {
        var formData = FormManager.getAllInputValue(formContentId);

        if (beforeSubmit && miloCore.isFunction(beforeSubmit) && !beforeSubmit(formData)) {
          return;
        }

        for (var key in formData) {
          var val = formData[key];

          switch (key) {
            case 'sName':
              {
                if (!val) {
                  self.commonValidator({
                    key: key,
                    val: '姓名不能为空'
                  }, onValidator);
                  return;
                }

                break;
              }
            // case 'iGender': {
            //   if (!val) {
            //     self.commonValidator({key, val:'性别必须选择' }, onValidator);  return;
            //   }
            //   break;
            // }

            case 'sIdentity':
              {
                if (!val) {
                  self.commonValidator({
                    key: key,
                    val: '身份证号码不能为空'
                  }, onValidator);
                  return;
                }

                if (!miloCore.util.isIDCard(val)) {
                  self.commonValidator({
                    key: key,
                    val: '身份证号码有误。'
                  }, onValidator);
                  return;
                }

                break;
              }

            case 'sMobile':
              {
                if (!val) {
                  self.commonValidator({
                    key: key,
                    val: '手机号码不能为空'
                  }, onValidator);
                  return;
                }

                if (!miloCore.util.isTel(val)) {
                  self.commonValidator({
                    key: key,
                    val: '请输入正确的手机号码'
                  }, onValidator);
                  return;
                }

                break;
              }

            case 'sAddress':
              {
                if (!val) {
                  self.commonValidator({
                    key: key,
                    val: '详细地址不能为空'
                  }, onValidator);
                  return;
                }

                break;
              }
            // case 'sPostCode': {
            //   if (!val) {
            //     self.commonValidator({key, val:'邮政编码不能为空' }, onValidator); return
            //   }
            //   if (!miloCore.util.isZipCode(val)) {
            //     self.commonValidator({key, val:'请输入正确的邮政编码。' }, onValidator); return
            //   }
            //   break;
            // }

            case 'sProvince':
              {
                if (!val) {
                  self.commonValidator({
                    key: key,
                    val: '请选择省份'
                  }, onValidator);
                  return;
                }

                break;
              }

            case 'sCity':
              {
                if (!val) {
                  self.commonValidator({
                    key: key,
                    val: '请选择城市'
                  }, onValidator);
                  return;
                }

                break;
              }

            default:
              {}
          }
        }

        self.submit(formData, function (res) {
          self.close();

          if (onSubmitSuccess && miloCore.isFunction(onSubmitSuccess)) {
            onSubmitSuccess(res);
          } else {
            miloAlert(res.sMsg || '添加成功');
          }
        }, function (err) {
          commonFail(err, err.errMsg || '网络繁忙，请稍后重试', onSubmitFail);
        });
      };
      var cancelBtnDoms = findNodeByClass(self.dialogRender, 'close-dialog');
      cancelBtnDoms.forEach(function (item) {
        item.onclick = function () {
          self.close();
        };
      });
    }
  }, {
    key: "close",
    value: function close() {
      if (this.dialogRender) {
        this.dialogRender.style.display = 'none';
      }
    }
  }]);

  return ShipAddressComp;
}();

export { ShipAddressComp as default };
export var ShipAddress = {
  init: function init(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new ShipAddressComp(option);
        resolve(instance);
      } catch (e) {
        reject({
          errCode: -2,
          errMsg: '实物中奖信息填写模块初始化失败'
        });
      }
    });
  }
};